import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';

export const app = initializeApp({
  apiKey: import.meta.env.VITE_FIREBASE_APIKEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTHDOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASEURL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECTID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGEBUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGINGSENDERID,
  appId: import.meta.env.VITE_FIREBASE_APPID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENTID,
});

// DO NOT REMOVE — without this, SET.Bio pages render blank for up to ~30s in
// WebKit (Safari on macOS/iOS, and every iOS in-app browser such as
// Instagram/Facebook). See ENG-2105.
//
// The browser build of @firebase/firestore sets `useFetchStreams: true`, which
// runs the WebChannel streaming transport over `fetch()` + ReadableStream.
// WebKit buffers those chunks instead of delivering them as they arrive, so
// server messages land in clumps tens of seconds late — Firestore debug logs
// show `targetChange` messages arriving ~30s after the `readTime` the server
// stamped on them. Since Firestore only applies received documents at a global
// snapshot boundary, one buffered message stalls *every* listener, and the page
// renders the profile (already delivered) above an empty content area.
//
// `experimentalAutoDetectLongPolling` (the SDK default) does not save us: its
// probe passes early, so it logs "detected no buffering proxy" on a stream that
// is in fact being buffered. Forcing long-polling skips streaming entirely, so
// there is nothing to buffer — and it also covers real buffering proxies, which
// the alternative fix (`useFetchStreams: false`) would not.
//
// The tradeoff is accepted deliberately: realtime updates arrive slightly later
// and each update cycle costs an HTTP request, in every browser. SET.Bio pages
// are read-once — visitors do not sit watching for live edits — so the lost
// streaming latency is worth far less than a blank page.
//
// Cannot be combined with `experimentalAutoDetectLongPolling`; the SDK throws
// INVALID_ARGUMENT if both are set.
export const firestore = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});

export const auth = getAuth(app);
